import { render, staticRenderFns } from "./MoreInfo.vue?vue&type=template&id=4ff55176&scoped=true"
import script from "./MoreInfo.vue?vue&type=script&lang=js"
export * from "./MoreInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff55176",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ff55176')) {
      api.createRecord('4ff55176', component.options)
    } else {
      api.reload('4ff55176', component.options)
    }
    module.hot.accept("./MoreInfo.vue?vue&type=template&id=4ff55176&scoped=true", function () {
      api.rerender('4ff55176', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sfe/storeDetails/components/MoreInfo.vue"
export default component.exports